module.exports = __webpack_public_path__ + "assets/img/resources.79ae25bf.png";